import { render, staticRenderFns } from "./InstallPromptCard.vue?vue&type=template&id=0177a64c&scoped=true&"
import script from "./InstallPromptCard.vue?vue&type=script&lang=ts&"
export * from "./InstallPromptCard.vue?vue&type=script&lang=ts&"
import style0 from "./InstallPromptCard.vue?vue&type=style&index=0&id=0177a64c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0177a64c",
  null
  
)

export default component.exports